import { blockLetterOnDocumentVerifiers, maskCNPJ, maskCPF } from 'src/helpers/string-helpers';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective, ValidatorFn, Validators } from '@angular/forms';
import { Subscription, distinctUntilChanged } from 'rxjs';
import { InvalidFieldMessageService } from 'src/app/services/invalid-field-message/invalid-field-message.service';
import { CnpjValidator } from 'src/validators/cnpj/cnpj';
import { CpfValidator } from 'src/validators/cpf/cpf';
@Component({
  selector: 'app-company-document',
  templateUrl: './company-document.component.html',
  styleUrls: ['./company-document.component.scss'],
})
export class CompanyDocumentComponent implements OnInit, OnDestroy {
  @ViewChild('documentInput') documentInput?: ElementRef;

  get messageError() {
    return this.messageService;
  }
  @Input() dataTest!: string;
  @Input() showIcon: boolean = false;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() required: boolean = true;
  @Output() blurOrEnter = new EventEmitter<string>();
  form!: FormGroup;
  formControlDocument!: AbstractControl
  private valueChanges$!: Subscription;
  private validators: ValidatorFn[] = [];

  constructor(private rootFormGroup: FormGroupDirective,
    private messageService: InvalidFieldMessageService,
  ) { }

  ngOnDestroy(): void {
    this.valueChanges$.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
    this.formControlDocument = this.form.controls[this.controlName];
    this.formatIfHasValue(this.formControlDocument.value)
    this.setValidators();
    this.detectValueChanges();
  }

  private formatIfHasValue(document: string) {
    if (document) {
      const raw = document.replace(/[.\-/]/g, '').toUpperCase();
      const hasLetter = /[A-Z]/.test(raw);
      if (!hasLetter && raw.length <= 11) {
        this.formControlDocument.setValue(maskCPF(raw));
      } else {
        this.formControlDocument.setValue(maskCNPJ(raw));
      }
    }
  }

  private setValidators() {
    this.validators = [
      Validators.maxLength(18),
      Validators.minLength(14),
    ];

    if (this.required)
      this.validators.push(Validators.required)

    this.formControlDocument.setValidators(this.validators);
    // this.formControlDocument.setAsyncValidators([
    //   this.documentValidator.isAvailable()
    // ]); Setado essa validação no signup
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    blockLetterOnDocumentVerifiers(event, this.formControlDocument.value);
  }

  onBlurOrEnter(): void {
    this.blurOrEnter.emit(this.formControlDocument.value);
  }

  public focus(): void {
    this.documentInput?.nativeElement.focus();
  }

  detectValueChanges() {
    this.valueChanges$ = this.formControlDocument.valueChanges.pipe(distinctUntilChanged())
      .subscribe(value => {
        if (!this.required) {
          this.formControlDocument.clearValidators();
        }
        if (value) {
          this.formControlDocument.clearValidators();

          const rawFull = value.replace(/[.\-/]/g, '').toUpperCase();
          // Garante que posições 13-14 (DVs) sejam somente dígitos
          const raw = rawFull.length > 12
            ? rawFull.substring(0, 12) + rawFull.substring(12).replace(/[^0-9]/g, '')
            : rawFull;
          const hasLetter = /[A-Z]/.test(raw);
          if (value.length <= 0) {
            this.formControlDocument.setValidators(this.validators);
          } else if (hasLetter || raw.length > 11) {
            // CNPJ: numérico ou alfanumérico
            this.formControlDocument.setValidators([
              ...this.validators,
              Validators.pattern(/^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/),
              CnpjValidator.isValid
            ]);
            this.formControlDocument.setValue(maskCNPJ(value));
          } else {
            // CPF: somente dígitos
            this.formControlDocument.setValidators([
              ...this.validators,
              Validators.pattern(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/),
              CpfValidator.isValid,
            ]);
            this.formControlDocument.setValue(maskCPF(value));
          }
        }

      });
  }

}
